/**
 * @generated SignedSource<<44c4c602981379c50b9e8117cb3d2816>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type productPeriodOrder_productPeriodOrdersQuery$variables = {};
export type productPeriodOrder_productPeriodOrdersQuery$data = {
  readonly productPeriodOrders: ReadonlyArray<{
    readonly ordering: number | null;
    readonly periodText: string;
  }>;
};
export type productPeriodOrder_productPeriodOrdersQuery = {
  response: productPeriodOrder_productPeriodOrdersQuery$data;
  variables: productPeriodOrder_productPeriodOrdersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductPeriodOrder",
    "kind": "LinkedField",
    "name": "productPeriodOrders",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "periodText",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ordering",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "productPeriodOrder_productPeriodOrdersQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "productPeriodOrder_productPeriodOrdersQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ea6a7c97680c9a9b5ea0588c16fb87a3",
    "id": null,
    "metadata": {},
    "name": "productPeriodOrder_productPeriodOrdersQuery",
    "operationKind": "query",
    "text": "query productPeriodOrder_productPeriodOrdersQuery {\n  productPeriodOrders {\n    periodText\n    ordering\n  }\n}\n"
  }
};
})();

(node as any).hash = "0534d90e84041b6ea2f51f793fb6a355";

export default node;
